import React from 'react';
import { Link } from 'react-router';
import SEOHead from '../../components/seo/seo-head';
import { SEO_CONFIG } from '../../constants/seo-config';
import AuthMixin from '../../mixins/authenticationMixin';
import CONSTANTS from '../../constants/constants';
import AppRoutes from '../../routes/routes';
import PageHeader from '../../components/banners/page-header';
import './404.scss';

class PageNotFound extends React.Component {
  render() {
    return (
      <div className="not-found-page">
        <SEOHead {...SEO_CONFIG.fourOhFour} />
        <PageHeader eyebrow="Error 404" title="Page not found">
          <p>We can't find the page you're looking for. It may have moved, or the link may be wrong.</p>
        </PageHeader>
        <div className="page-content not-found-content">
          <div className="not-found-actions">
            <Link to={AppRoutes.homepage} className="btn btn-primary-sm">Go to the homepage</Link>
            <Link to={AppRoutes.explore} className="not-found-secondary">Explore the database</Link>
          </div>
          <p className="not-found-help">If you followed a link here, please let us know at <a href={`mailto:${CONSTANTS.CONTACT_EMAIL}`}>{CONSTANTS.CONTACT_EMAIL}</a>.</p>
        </div>
      </div>
    )
  }
}

export default AuthMixin(PageNotFound);
